<app-layout columnCount="12" maxWidth="70rem">
  <app-layout-title (click)="goBack()">
    <app-go-back-button>
      {{ 'ADMIN.invite_users' | translate }}
    </app-go-back-button>
  </app-layout-title>

  <app-layout-actions>
    <mat-form-field class="actions">
      <mat-label>{{ 'ACCOUNT.role' | translate }}</mat-label>
      <mat-select [(ngModel)]="role" (ngModelChange)="resetSelectedProjects()">
        <mat-option value="ROLE_MANAGER">{{ 'USER_ROLES.manager' | translate }}</mat-option>
        <mat-option value="ROLE_ROOT_ACCESS">{{ 'USER_ROLES.admin' | translate }}</mat-option>
        <mat-option *isDev value="ROLE_DEVELOPER">{{ 'USER_ROLES.developer' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </app-layout-actions>

  <app-layout-content>
    @if (role === 'ROLE_MANAGER') {
      <div class="projects-list">
        @for (project of selectedProjects; track project) {
          <mat-checkbox [(ngModel)]="project.isSelected">
            <app-project-view [name]="project.name" [iso]="project.isoCode"></app-project-view>
          </mat-checkbox>
        }
      </div>
    } @else {
      <div class="all-projects">{{ 'ADMIN.all_projects_hint' | translate }}</div>
    }
    <ul class="invite-links">
      @for (link of inviteLinks; track link; let i = $index) {
        <li>
          <button (click)="copyInvite(i)" mat-icon-button>
            <mat-icon color="primary">file_copy</mat-icon>
          </button>
          <span class="link">{{link}}</span>
        </li>
      }
    </ul>

    <app-button-group>
      <app-yes-no (action)="generateInvite()" (cancel)="goBack()" [actionName]="'ADMIN.generate_link' | translate"></app-yes-no>
    </app-button-group>
  </app-layout-content>
</app-layout>
